import type { DataTableBodyStore } from "@src/components/ui-kit/DataTable/Body/store";
import type {
  BodyProps,
  BodyRow,
} from "@src/components/ui-kit/DataTable/types";
import { useEffect } from "react";

interface UseTableBodyStoreSyncArgs<Row extends BodyRow>
  extends Pick<
    BodyProps<Row, unknown>,
    "selected" | "bulkActions" | "onSelect" | "allIds"
  > {
  store: DataTableBodyStore;
}
export function useTableBodyStoreSync<Row extends BodyRow>({
  store,
  selected,
  bulkActions,
  onSelect,
  allIds,
}: UseTableBodyStoreSyncArgs<Row>) {
  useEffect(() => {
    store.bulkActionsStore.setActions(bulkActions ?? []);
  }, [bulkActions, store.bulkActionsStore.setActions]);

  useEffect(() => {
    store.setOnSelect(onSelect);
  }, [onSelect, store.setOnSelect]);

  useEffect(() => {
    store.bulkActionsStore.setAllIds(allIds ?? []);
  }, [allIds, store.bulkActionsStore.setAllIds]);

  useEffect(() => {
    if (selected === undefined) {
      return;
    }

    store.bulkActionsStore.setSelectedIds(selected);
  }, [selected, store.bulkActionsStore.setSelectedIds]);

  return {};
}
